export default __webpack_public_path__ + "static/5-e5571c0e057d8763563d21cdd6534f62.png";